import { fromJS } from 'immutable';

import { GET_ALL_FRIENDS } from '../containers/constants';

const initialState = fromJS({});

export function allFriendsReducer(state = initialState, action){
	switch(action.type){
		case GET_ALL_FRIENDS:
			return {
				...state,
				data: action.payload
			};
		default:
			return state;		
	}	
}

//export default allFriendsReducer;
